import React from 'react';
import './PageHero.css';
import { getLongNameChamp } from '../variables';
import logoProAM from '../assets/proam.png'
import logoProBM from '../assets/probm.png'
import logoProAD from '../assets/proad.png'
import logoProBD from '../assets/probd.png'

const LOGOS = {proam: logoProAM, proad: logoProAD, probm: logoProBM, probd: logoProBD};

// Bannière des pages d'un championnat : logo, nom du championnat, titre de la page
function PageHero({championnat, title, subtitle}) {
    return (
        <div className={"page_hero " + championnat}>
            <div className="page_hero_inner">
                {
                    LOGOS[championnat] &&
                    <img src={LOGOS[championnat]} alt="Logo pro" className="page_hero_logo" />
                }
                <div className="page_hero_text">
                    <span className="page_hero_champ">{getLongNameChamp(championnat)}</span>
                    <h1 className="page_hero_title">{title}</h1>
                    {
                        subtitle &&
                        <span className="page_hero_subtitle">{subtitle}</span>
                    }
                </div>
            </div>
        </div>
    );
}

export default PageHero;
